function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptFlipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 18V13.5H44V9H42.5V7.5H41V6H39.5V4.5H38V3H35V1.5H29V0H18.5V1.5H12.5V3H9.5V4.5H8V6H6.5V7.5H5V9H3.5V13.5H2V18H0.5V28.5H2V33H3.5V37.5H5V39H6.5V40.5H8V42H9.5V43.5H12.5V45H18.5V46.5H29V45H35V43.5H38V42H39.5V40.5H41V39H42.5V37.5H44V33H45.5V28.5H47V18H45.5Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 24H15.5V27H18.5V24H20V19.5H17V24Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24H23V27H24.5V24Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 18V13.5H44V9H42.5V7.5H41V6H39.5V4.5H38V3H35V1.5H29V0H18.5V1.5H12.5V3H9.5V4.5H8V6H6.5V7.5H5V9H3.5V13.5H2V18H0.5V28.5H2V33H3.5V37.5H5V39H6.5V40.5H8V42H9.5V43.5H12.5V45H18.5V46.5H29V45H35V43.5H38V42H39.5V40.5H41V39H42.5V37.5H44V33H45.5V28.5H47V18H45.5ZM36.5 22.5H35V24H32V25.5H29V27H27.5V30H23V27H21.5V28.5H18.5V30H14V28.5H12.5V27H11V24H12.5V19.5H14V18H17V16.5H21.5V18H23V19.5H24.5V24H26V18H27.5V16.5H33.5V18H36.5V22.5Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 22.5H32V19.5H30.5V22.5Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptFlipped);
export default __webpack_public_path__ + "static/media/opt_flipped.f9bf7b38a105b614e8b43085289e860a.svg";
export { ForwardRef as ReactComponent };